import { fetcher } from "../../utils/fetcher";

export const updateBoardConfig = (boardId, configData) => {
  return fetcher.put(`/api/boards/${boardId}/config`, configData);
};
